<ul>
  <li *ngFor="let file of files">
    <a [routerLink]="['/file', file._id.$oid]">{{ file.filename }}</a>
  </li>
</ul>
